// import { errors } from './errors'
import { isNumeric } from "common/helpers/utils";

const _ONE_DAY = 86400;
const _PLUS_ONE_DAY = "(+1d)";
const _lang = {
  am: "am",
  pm: "pm",
  AM: "AM",
  PM: "PM",
  decimal: ".",
  mins: "mins",
  hr: "hr",
  hrs: "hrs",
};

const pad = (num, padChar, size) => {
  const s = padChar + padChar + padChar + num;
  return s.substr(s.length - size);
};

const firstNumericPart = (myString, retval = "") => {
  if (!myString) {
    return retval;
  }

  if (isNumeric(myString[0])) {
    return firstNumericPart(myString.substr(1), retval + myString[0]);
  }
  return retval;
};

const firstNonNumericPart = (myString) => {
  return myString.replace(firstNumericPart(myString), "");
};

// return integer minutes since midnight if parsesable, otherwise null
// export const parseTimeString = (timeString, dayCutoff = 0) => {
//   if(_.includes(timeString,":")) {
//     var timeSplit = _.split(timeString, ':')
//   }
//   else if( _.includes(timeString,".") ) {
//     var timeSplit = _.split(timeString, '.')
//   }
//   else {
//     // there's no colon or dot
//     // let's try to make sense of the numeric part at the beginning.
//     // the non-numeric part will be treated later as a period - if it's not a valid period, that will count as an error
//     var numericPart = firstNumericPart(timeString)

//     if(numericPart.length > 4) {
//       return null
//     }
//     else if(numericPart.length > 2) {
//       var timeSplit = [numericPart.substr(0,numericPart.length - 2),timeString.substr(2)]
//     }
//     else {
//       var timeSplit = [timeString]
//     }
//   }

//   // get hour
//   if(timeSplit.length > 1) {
//     var hour = timeSplit[0]
//   }
//   else {
//     // maybe there's no colon, e.g. 1pm
//     var hour = firstNumericPart(timeSplit[0])
//   }

//   if( hour == '12' ) {
//     hour = '00'
//   }

//   if(!isNumeric(hour)) {
//     return null // if the part before the colon isn't numeric, we don't know what to do
//   }

//   var hourI = parseInt(hour)

//   // get minute
//   if(timeSplit[1]) {
//     var minuteI = parseInt(firstNumericPart(timeSplit[1]))
//   }
//   else {
//     var minuteI = 0 // maybe there's no colon, i.e. just entered the time as e.g. 1pm
//   }

//   // get period.  add 12 hours if PM
//   var periodAdjust = 0

//   var period = firstNonNumericPart(_.last(timeSplit)) // look for period at the end of the string

//   // handle 24-hour clock
//   if( hourI > 12 ) {
//     if(period.length > 0) {
//       // can't handle a period as well
//       return null
//     }
//     else {
//       hourI -= 12
//       period = 'p.m.'
//     }
//   }

//   if( period == 'p.m.' || period == 'pm' || period == 'p' ) {
//     periodAdjust += 12 * 3600
//   }
//   else if( period == '' || period == 'a.m.' || period =='am' || period == 'a' ) {
//     periodAdjust += 0
//   }
//   else {
//     return null // error if there's an unexpected period
//   }

//   if(hourI > 12 || minuteI >= 60) {
//     return null
//   }

//   var retval = hourI * 3600 + minuteI * 60 + periodAdjust

//   if(retval < dayCutoff) {
//     retval += 3600 * 24
//   }

//   return retval
// }

export const parseTimeString = (timeString, settings = {}) => {
  if (timeString === "" || timeString === null) return null;
  if (typeof timeString === "object") {
    return (
      timeString.getHours() * 3600 +
      timeString.getMinutes() * 60 +
      timeString.getSeconds()
    );
  }
  if (typeof timeString !== "string") {
    return timeString;
  }

  timeString = timeString.toLowerCase().replace(/[\s\.]/g, "");

  // if the last character is an "a" or "p", add the "m"
  if (timeString.slice(-1) == "a" || timeString.slice(-1) == "p") {
    timeString += "m";
  }

  const ampmRegex = `(${_lang.am.replace(".", "")}|${_lang.pm.replace(
    ".",
    ""
  )}|${_lang.AM.replace(".", "")}|${_lang.PM.replace(".", "")})?`;

  // try to parse time input
  const pattern = new RegExp(
    `^${ampmRegex}([0-9]?[0-9])\\W?([0-5][0-9])?\\W?([0-5][0-9])?${ampmRegex}$`
  );

  let time = timeString.match(pattern);

  // If the time could not be parsed with the regex or has fewer than 2 match elements, return null which will be handled by the caller
  const MINIMUM_MATCH_LENGTH = 3;
  if (!time || time.length < MINIMUM_MATCH_LENGTH) return null;

  if (timeString.includes(_PLUS_ONE_DAY)) {
    time = timeString.replace(_PLUS_ONE_DAY, "").trim().match(pattern);
  }

  const hour = parseInt(time[2] * 1, 10);
  const ampm = time[1] || time[5];
  let hours = hour;
  const minutes = time[3] * 1 || 0;
  const seconds = time[4] * 1 || 0;

  if (hour <= 12 && ampm) {
    const isPm = ampm == _lang.pm || ampm == _lang.PM;

    if (hour == 12) {
      hours = isPm ? 12 : 0;
    } else {
      hours = hour + (isPm ? 12 : 0);
    }
  } else if (settings) {
    const t = hour * 3600 + minutes * 60 + seconds;
    if (t >= _ONE_DAY + (settings.show2400 ? 1 : 0)) {
      if (settings.wrapHours === false) {
        return null;
      }

      hours = hour % 24;
    }
  }

  let timeInt = hours * 3600 + minutes * 60 + seconds;

  // if no am/pm provided, intelligently guess based on the scrollDefault
  if (
    hour < 12 &&
    !ampm &&
    settings &&
    settings._twelveHourTime &&
    settings.scrollDefault
  ) {
    const delta = timeInt - settings.scrollDefault();
    if (delta < 0 && delta >= _ONE_DAY / -2) {
      timeInt = (timeInt + _ONE_DAY / 2) % _ONE_DAY;
    }
  }

  return timeInt;
};

export const defaultTimes = (start = null) => {
  const increment = 3600 / 2;

  if (start == null) {
    start = 0;
  } else {
    start = Math.floor(start / increment) * increment + increment;
  }

  let retval = [];
  const end = start + 3600 * 24;
  for (let i = start; i < end; i += increment) {
    retval = retval.concat([i]);
  }
  return retval;
};

export const timeDisplay = (timeInteger) => {
  if (timeInteger == null) {
    return null;
  }

  const day = Math.floor(timeInteger / 3600 / 24.0);

  timeInteger %= 3600 * 24;
  let hour = Math.floor(timeInteger / 3600) % 12;
  hour = hour == 0 ? 12 : hour;
  const minute = Math.floor(timeInteger / 60) % 60;
  const period = timeInteger < 3600 * 12 ? "am" : "pm";

  let retval = `${hour}:${pad(minute, "0", 2)} ${period}`;

  if (day > 0) {
    retval += ` (+${day}d)`;
  }

  return retval;
};

// export const calcPaidHours = (shift, type = "employee") => {
//   if(Object.keys(errors(shift)).length > 0) {
//     return null
//   }
//   if (type !== 'employee' && shift.hours_worked_employer) {
//     return shift.hours_worked_employer
//   }

//   var workingHours = 0;
//   var ptoHours = 0;

//   if(shift.starts_at_employee != null && shift.ends_at_employee != null) {
//     workingHours += (shift.ends_at_employee - shift.starts_at_employee) / 3600

//     if(shift.hours_break_employee != null) {
//       workingHours -= shift.hours_break_employee
//     }
//   }

//   if(shift.hours_pto_employee != null) {
//     ptoHours += shift.hours_pto_employee
//   }

//   return workingHours + ptoHours
// }

// export const calcTotalHours = (shifts) => {
//   return Object.values(shifts).reduce( (sum,shift) => {
//       return sum + calcPaidHours(shift)
//     },
//     0
//   )
// }

// class Timepicker {
//   _ONE_DAY = 86400

//   _lang = {
//     am: "am",
//     pm: "pm",
//     AM: "AM",
//     PM: "PM",
//     decimal: ".",
//     mins: "mins",
//     hr: "hr",
//     hrs: "hrs"
//   }

//   _DEFAULTS = {
//     appendTo: "body",
//     className: null,
//     closeOnWindowScroll: false,
//     disableTextInput: false,
//     disableTimeRanges: [],
//     disableTouchKeyboard: false,
//     durationTime: null,
//     forceRoundTime: false,
//     maxTime: null,
//     minTime: null,
//     noneOption: false,
//     orientation: "l",
//     roundingFunction: (seconds, settings) => {
//       if (seconds === null) {
//         return null;
//       } else if (typeof settings.step !== "number") {
//         // TODO: nearest fit irregular steps
//         return seconds;
//       } else {
//         var offset = seconds % (settings.step * 60); // step is in minutes

//         var start = settings.minTime || 0;

//         // adjust offset by start mod step so that the offset is aligned not to 00:00 but to the start
//         offset -= start % (settings.step * 60);

//         if (offset >= settings.step * 30) {
//           // if offset is larger than a half step, round up
//           seconds += settings.step * 60 - offset;
//         } else {
//           // round down
//           seconds -= offset;
//         }

//         return _moduloSeconds(seconds, settings);
//       }
//     },
//     scrollDefault: null,
//     selectOnBlur: false,
//     show2400: false,
//     showDuration: false,
//     showOn: ["click", "focus"],
//     showOnFocus: true,
//     step: 30,
//     stopScrollPropagation: false,
//     timeFormat: "g:ia",
//     typeaheadHighlight: true,
//     useSelect: false,
//     wrapHours: true
//   }
// }

// export default Timepicker
